/**
 * Test ID utilities for Tooltip component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Tooltip trigger
 * @param identifier - Tooltip identifier
 * @returns Test ID string
 */
export const setTooltipTriggerTestId = (identifier: string): string =>
  generateTestId("TooltipTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Tooltip content
 * @param identifier - Tooltip identifier
 * @returns Test ID string
 */
export const setTooltipContentTestId = (identifier: string): string =>
  generateTestId("TooltipContent", identifier.replace(/\s+/g, "-").toLowerCase());
